import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from 'axios';
import qs from 'qs';
import { get, post, put, deletes } from '@/api/fetch.js';
import url from '@/api/serviceAPI.config.js';
export default {
  name: 'qualitySummaryTable',
  components: {},
  data: function data() {
    var checkDesc = function checkDesc(rule, value, callback) {
      if ((value == null || value.trim() == '') && rule.required == true) {
        callback(new Error('问题描述不能为空'));
      } else {
        callback();
      }
    };
    var checkReply = function checkReply(rule, value, callback) {
      if ((value == null || value.trim() == '') && rule.required == true) {
        callback(new Error('处理回复不能为空'));
      } else {
        callback();
      }
    };
    return {
      listLoading: false,
      dialogChooseVisible: true,
      filterForm: {
        businessId: '',
        describes: '',
        state: '',
        participateCompany: '',
        createUserName: '',
        companyId: ''
      },
      typeList: [],
      pageSize: 10,
      pageNum: 0,
      currentPage: 1,
      totalCount: 0,
      editStatus: 0,
      showDialog: false,
      editForm: {
        id: '',
        type: '',
        describes: '',
        file: '',
        reply: '',
        pics: [],
        pic: '',
        videos: [],
        video: ''
      },
      videoList: [],
      videoStatus: true,
      picList: [],
      url: url.fileUrl,
      //测试及正式
      //项目选择
      projectList: [],
      tableData: [],
      companyList: [],
      //租户公司列表
      rules: {
        type: [{
          required: true,
          message: '请选择问题类型',
          trigger: 'change'
        }],
        describes: [{
          required: true,
          validator: checkDesc,
          trigger: 'change'
        }],
        reply: [{
          required: true,
          validator: checkReply,
          trigger: 'change'
        }]
      }
    };
  },
  created: function created() {
    this.initData();
    this.initBaseData();
  },
  watch: {
    // 'filterForm.describes'(newVal, oldVal) {
    //     this.pageNum = 0;
    //     this.getTableData();
    // }
  },
  methods: {
    searchData: function searchData() {
      this.pageNum = 0;
      this.currentPage = 1;
      this.getTableData();
    },
    initData: function initData() {
      this.getTableData();
    },
    sizeChangeHandle: function sizeChangeHandle(val) {
      this.pageNum = 0;
      this.pageSize = val;
      this.currentPage = 1;
      this.getTableData();
    },
    currentChangeHandle: function currentChangeHandle(val) {
      this.currentPage = val;
      this.pageNum = val - 1;
      this.getTableData();
    },
    getTableData: function getTableData() {
      var _this = this;
      this.listLoading = true;
      var startTime = '';
      var endTime = '';
      // if (this.filterForm.leaveTime && this.filterForm.leaveTime.length > 0) {
      //   startTime = this.filterForm.leaveTime[0];
      //   endTime = this.filterForm.leaveTime[1];
      // }

      get(url.problemFeedback.searchProblemList, {
        describes: this.filterForm.describes,
        state: this.filterForm.state,
        companyId: this.filterForm.companyId,
        participateCompany: this.filterForm.participateCompany,
        createName: this.filterForm.createUserName,
        pageSize: this.pageSize,
        pageNum: this.pageNum
      }).then(function (res) {
        _this.filterForm.businessId = '';
        if (res.code == 200) {
          _this.tableData = res.data.list;
          _this.pageSize = res.data.pageSize;
          _this.pageNum = res.data.pageNum;
          _this.totalCount = res.data.total;
          // console.log("leaveRes", res, this.tableData);
        } else {
          console.log(res.msg);
        }
        _this.listLoading = false;
      });
    },
    deleteData: function deleteData(row) {
      var _this2 = this;
      this.$confirm('此操作将删除该问题, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        if (_this2.tableData.length == 1 && _this2.pageNum != 0) {
          _this2.currentPage = _this2.pageNum;
          _this2.pageNum = _this2.pageNum - 1;
        }
        post(url.problemFeedback.deleteProblem + '?id=' + row.id).then(function (res) {
          if (res.code == 200) {
            _this2.$message({
              type: 'success',
              message: '删除成功!'
            });
            _this2.getTableData();
          }
        });
      }).catch(function () {
        _this2.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    editData: function editData(num, obj) {
      var _this3 = this;
      this.editStatus = num;
      if (this.editStatus == 0) {
        this.rules.reply[0].required = false;
        this.rules.type[0].required = true;
        this.rules.describes[0].required = true;
        this.showDialog = true;
      } else {
        this.rules.reply[0].required = true;
        this.rules.type[0].required = false;
        this.rules.describes[0].required = false;
        this.editForm.id = obj.id;
        get(url.problemFeedback.getProblemDetails, {
          id: obj.id
        }).then(function (res) {
          if (res.code == 200) {
            var _res$data = res.data,
              id = _res$data.id,
              typeValue = _res$data.typeValue,
              describes = _res$data.describes,
              pictureFile = _res$data.pictureFile,
              videoFile = _res$data.videoFile,
              reply = _res$data.reply;
            console.log('video', videoFile);
            _this3.editForm.id = id;
            _this3.editForm.type = typeValue;
            _this3.editForm.describes = describes;
            _this3.editForm.pics = pictureFile == null ? [] : pictureFile;
            _this3.editForm.videos = videoFile == null ? '' : videoFile;
            _this3.editForm.reply = reply;
            _this3.showDialog = true;
          }
        });
      }
    },
    submitData: function submitData() {
      var _this4 = this;
      console.log('rules', this.rules);
      this.$refs.editForm.validate(function (val) {
        if (val) {
          // if (this.editForm.pics.length > 0) {
          //     this.editForm.pics.forEach((item, index) => {
          //         this.editForm.pic += item.id + ',';
          //     });
          // }
          // if (this.editForm.videos.length > 0) {
          //     this.editForm.videos.forEach((item, index) => {
          //         this.editForm.video += item.id + ',';
          //     });
          // }
          var instance = axios.create();
          // instance.defaults.headers.post["content-type"] = "application/json";
          console.log('editForm', _this4.editForm);
          if (_this4.editStatus == 0) {
            instance.post(url.problemFeedback.addProblem, {
              describes: _this4.editForm.describes,
              type: _this4.editForm.type,
              pictureFileIds: _this4.editForm.pic,
              videoFileId: _this4.editForm.video
            }).then(function (res) {
              if (res.data.code == 200) {
                _this4.$message.success('操作成功');
                _this4.getTableData();
                _this4.cancelSubmitData();
              } else {
                _this4.$message.console.error(res.data.msg);
              }
            });
          } else {
            instance.post(url.problemFeedback.updateProblem, {
              id: _this4.editForm.id,
              reply: _this4.editForm.reply
            }).then(function (res) {
              if (res.data.code == 200) {
                _this4.$message.success('操作成功');
                _this4.getTableData();
                _this4.cancelSubmitData();
              } else {
                _this4.$message.error(res.data.msg);
              }
            });
          }
          console.log('editForm', _this4.editForm);
        }
      });
      // this.showDialog = false;
    },
    cancelSubmitData: function cancelSubmitData() {
      this.editForm = {
        id: '',
        type: '',
        describes: '',
        pics: [],
        pic: '',
        videos: [],
        video: '',
        reply: ''
      };
      this.picList = [];
      this.videoList = [];
      this.showDialog = false;
    },
    // 预览图片
    previewPic: function previewPic(row) {
      window.open(this.url + row);
    },
    uploadFile1: function uploadFile1() {
      this.$message.error('视频文件只能上传一个');
    },
    uploadFile9: function uploadFile9() {
      this.$message.error('图片文件最多上传九张');
    },
    uploadVideo: function uploadVideo(file, fileList) {
      var _this5 = this;
      var isLt50M = file.size / 1024 / 1024 < 50;
      if (!isLt50M) {
        this.$message.error('上传的视频大小不能超过50M!');
        fileList.splice(0, 1);
        return;
      }
      this.videoStatus = false;
      var instance = axios.create();
      var pm = new FormData();
      pm.append('type', 'problemVideo');
      fileList.forEach(function (item, index) {
        pm.append('file', item.raw);
      });
      instance.post(url.meetingManage.uploadMeetingFile, pm).then(function (res) {
        if (res.data.code == 200) {
          _this5.$message.success('上传成功');
          console.log('res', res);
          _this5.editForm.videos = res.data.data;
          _this5.videoStatus = true;
        } else {
          _this5.$message.console.error();
          '上传失败';
        }
      });
    },
    uploadPic: function uploadPic(file, fileList) {
      var _this6 = this;
      var isLt50M = file.size / 1024 / 1024 < 50;
      if (!isLt50M) {
        this.$message.error('上传的图片大小不能超过50M!');
      } else {
        if (this.timeout) {
          clearTimeout(this.timeout);
        }
        this.timeout = setTimeout(function () {
          var instance = axios.create();
          var pm = new FormData();
          pm.append('type', 'problemImg');
          fileList.forEach(function (item, index) {
            pm.append('file', item.raw);
          });
          _this6.editForm.pics = [];
          instance.post(url.meetingManage.uploadMeetingFile, pm).then(function (res) {
            if (res.data.code == 200) {
              _this6.$message.success('上传成功');
              res.data.data.forEach(function (item, index) {
                _this6.editForm.pics.push(item);
              });
              console.log('res', res);
            } else {
              _this6.$message.console.error();
              '上传失败';
            }
          });
        }, 500);
      }
    },
    // 删除视频
    deleteFile: function deleteFile(type, row) {
      var _this7 = this;
      this.editForm.videos.forEach(function (item, index) {
        if (item.id == row.id) {
          _this7.editForm.videos.splice(index, 1);
          _this7.videoList.splice(0, 1);
        }
      });
      console.log('vide', this.editForm.videos);
    },
    // 删除图片
    beforeRemoveSub: function beforeRemoveSub(file) {
      var _this8 = this;
      this.editForm.pics.map(function (item, index) {
        if (file.id) {
          if (item.id == file.id) {
            _this8.editForm.pics.splice(index, 1);
          }
        } else {
          if (item.name == file.name) {
            _this8.editForm.pics.splice(index, 1);
          }
        }
      });
    },
    initBaseData: function initBaseData() {
      var _this9 = this;
      var pm = {
        pageNum: 0,
        pageSize: 10000000
      };

      // 获取租户公司列表
      get(url.company.searchList, pm).then(function (res) {
        console.log('res', res);
        if (res.status == 200) {
          _this9.companyList = res.data.datas;
        }
      });
    }
  }
};